import { Box } from '@alf/uikit';
import { SupportChat } from '@namespace/chats';
import ChatButton from './components/ChatButton';

import styles from './index.module.css';

const HeaderContactInfoWithCustomChat = () => (
  <Box direction="column" className={styles.wrapper}>
    <SupportChat buttonClassName={styles.chatButton} ChatButton={ChatButton} />
  </Box>
);

export default HeaderContactInfoWithCustomChat;
